module.exports = __webpack_public_path__ + "static/img/external_ tiktok.e71fa9aa.svg";